import { Component, OnInit } from '@angular/core';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';

@Component({
    selector: 'app-team-profile-player-card',
    templateUrl: './team-profile-player-card.component.html',
    styleUrls: ['./team-profile-player-card.component.css'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatGridList, MatGridTile]
})
export class TeamProfilePlayerCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
